module.exports = __webpack_public_path__ + "img/4d0cb1a.jpg";